<template>
  <div id="Haomaluzhu">
    <div class="tr-header">
      <p class="title">号码前后路珠</p>
      <div class="dayHandles">
        <DatePick @onchange="onchangeDate"></DatePick>
      </div>
    </div>
    <div class="tr-header-container">
      <div class="handle-con">
        <div class="title">
          <span>筛选号码</span>
          <div class="handles" style="display:inline-block;padding-left:20px">
            <CheckboxGroup v-model="selectBalls">
              <Checkbox :label="it.key" v-for="(it,i) in balls" :key="i">号码{{i + 1}}</Checkbox>
              <Button type="text" @click="reset">全选</Button>
              <Button type="text" @click="selectBalls=[]">清空</Button>
              <!-- <Checkbox :label="i" v-for="(it,i) in dataSource" :key="i">号码{{i + 1}}</Checkbox> -->
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </div>
    <div class="tr-table-container">
      <Road
        v-for="(it,i) in dataSource"
        :data="it"
        :date="date"
        :key="i"
        v-if="~selectBalls.indexOf(Object.keys(it)[0])"
      ></Road>
      <!-- <Road v-for="(it,i) in roadsData" :data="it" :key="i" v-if="~selectBalls.indexOf(i)"></Road> -->
      <div class="food_meg">
        <p>1, 表格需从左向右浏览，右侧一列为最新结果；</p>
        <p>2, 当长龙中断时，则另起一列显示结果；</p>
        <p>3, “号码1” 表示球号1在每一期中开出的前后位置；</p>
        <p>4, “前”表示号码开出在前5名，“后”表示号码开出在后5名;</p>
      </div>
    </div>
  </div>
</template>

<script>
import DatePick from "../components/DatePick";
import dayjs from "dayjs";
import statistic from "../../../helpers/statistic";
import Road from "./Road";
import format from "../../../helpers/format.js";

function setBall(start, len) {
  let res = [];
  for (let i = start; i <= len; i++) {
    res.push({
      name: `号码${i}`,
      key: `num${i}`
    });
  }
  return res;
}
const sscBalls = setBall(0, 9);
const ksBalls = setBall(1, 6);

export default {
  name: "Haomaluzhu",
  components: {
    DatePick,
    Road
  },
  data() {
    return {
      selectDay: dayjs(new Date()).format("YYYY-MM-DD"),
      dataSource: [],
      date: "",
      balls: [],
      selectBalls: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    roadsData() {
      return statistic.getBallRoads(this.betType, this.dataSource);
    }
  },
  created() {
    this.reset();
  },
  methods: {
    onchangeDate(date) {
      this.selectDay = dayjs(date).format("YYYY-MM-DD");
      this.getData();
    },
    reset() {
      this.balls = setBall(0, 9);

      this.selectBalls = this.balls.map(x => x.key);
    },
    init() {
      this.getData();
    },
    async getData() {
      // this.dataSource = [];
      let res = await this.$http.post("/queryKcDateReport.do", {
        gameType: this.$route.params.gameType,
        // pageSize: this,
        date: this.selectDay
        // endDate: this.selectDay
      });

      if (res.data.returnCode == "0000") {
        // this.dataSource = [];
        // console.log("res", res.data.returnList);
        if (res.data.returnList[0]) {
          this.date = res.data.returnList[0].date;
        }
        // console.log("ss", this.date);
        var arr = format.formatJson(res.data.returnList);
        if (arr.length > 0) {
          var a = this.formatList(arr[0].num_dewdrop_json);
          this.dataSource = a;
        }
      } else {
        // this.$Message.error(res.data.returnMessage);
      }
    },
    formatList(obj) {
      var keys = Object.keys(obj);
      var arr = [];
      for (let i = 0; i < keys.length; i++) {
        var o = {};
        const e = keys[i];
        o[e] = obj[e];
        var n = parseInt(e.slice(-1));
        // console.log(n, e);

        // arr.push(o);
        arr[n] = o;
      }

      return arr;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>




// WEBPACK FOOTER //
// src/pages/Trend/Haomaqianhouluzhu/index.vue